<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth"
  >
    <h2 class="modal__title">
      Стоимость изменилась
    </h2>

    <div class="modal__body">
      <p class="modal__text">
        При окончательном расчете итоговая стоимость изменилась
      </p>

      <p class="modal__text">
        {{ costText }}
      </p>
      <p class="modal__text">
        {{ warningText }}
      </p>
    </div>

    <div class="modal__submit-buttons">
      <BaseButton
        text="Хорошо"
        size="large"
        @click.native="$emit('submit')"
      />

      <BaseButton
        class="modal__refuse"
        text="Назад"
        @click.native="$emit('close')"
      />
    </div>
  </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalPolicyIssuanceSuccess',
  components: {
    BaseButton
  },
  props: {
    costText: String,
    warningText: String,
  },
  mixins: [modal],
}
</script>

<style lang="scss" scoped>
.modal {
  &__refuse {
    color: rgba(#3d3d3d, 0.5);
    border: none;
    background-color: transparent;

    &:focus,
    &:hover {
      color: rgba(#3d3d3d, 0.5);
      border: none;
      background-color: transparent;
    }

    &:not(:last-child) {
      margin-right: rem(24);
    }
  }

  &__submit-buttons {
    justify-content: flex-start;
  }
}
</style>
